<script lang="ts" setup>
import Header from "@/components/organisms/common/Header.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { useRouter } from "vue-router";
import { onBeforeMount, ref } from "vue";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import MenuAnchorLinkItem from "@/components/organisms/mypage/MenuAnchorLinkItem.vue";
import MenuLinkGroup from "@/components/organisms/mypage/MenuLinkGroup.vue";
import { educationService } from "@/app/services/EducationService";
import { WorkerTrainingContent } from "@/types/educations/WorkerTrainingContent";
import {
  AnalyzeWorkerTrainingContentEvent,
  eventService
} from "@/app/services/EventService";
const loader = useLoader();
const errorModal = useErrorModal();
const router = useRouter();

const trainings = ref<WorkerTrainingContent[]>([]);

onBeforeMount(async () => {
  await fetchTrainings();
});

async function fetchTrainings() {
  loader.show();
  try {
    const workerTrainingContents = await educationService.fetchWorkerTrainingContents(
      { query: { ordering: "-created_at" } }
    );
    trainings.value = workerTrainingContents.results;
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
}

function onClickBack() {
  router.back();
}

function onClickMenuItem(workerTrainingContentId: number) {
  // イベントログを記録する。非同期で十分なのでawaitしない
  eventService.registerEvent(
    AnalyzeWorkerTrainingContentEvent.group,
    AnalyzeWorkerTrainingContentEvent.types.openTrainingContent,
    undefined,
    JSON.stringify({
      workerTrainingContentId
    })
  );
}
</script>

<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      研修
    </Header>
    <div class="py-4">
      <MenuLinkGroup>
        <MenuAnchorLinkItem
          v-for="training in trainings"
          :key="training.id"
          :label="training.title"
          :href="training.url"
          @click="onClickMenuItem(training.id)"
        />
      </MenuLinkGroup>
    </div>
  </div>
</template>
